import { post, get } from '@api/request';

export const searchMobileHomes = async (
  { appraisalService },
  authenticationToken,
  { pageSize, page, payload },
) => {
  const url = `${appraisalService}/appraisal/property/mobilehomesearch?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchMobileHomeSearchConfig = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/property/mobilehomesearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
};
